export default __webpack_public_path__ + "static/media/logo.11cf01e5.png";